import React, {Children, ReactElement, ReactNode} from 'react';
import {AvatarProps} from '@ui/avatar/avatar';
import clsx from 'clsx';
import {Trans} from '@ui/i18n/trans';
import {Link} from 'react-router-dom';
import { isMobile } from '@common/core/platform-detection';
import { StackTrigger } from '@ui/overlays/stack-navigator/stack-trigger';
import { ArtistPage } from '@app/web-player/routes/web-player-routes.lazy';

interface AvatarGroupProps {
  children: ReactNode;
  className?: string;
  showMore?: boolean;
}
export function AvatarGroup({
  children: propsChildren,
  showMore = true,
  className,
}: AvatarGroupProps) {
  const children = Children.toArray(
    propsChildren,
  ) as ReactElement<AvatarProps>[];

  if (!children.length) return null;
  
  const firstArtist = children[0].props.artist;
  const firstLink = children[0].props.link;
  const label = children[0].props.label;

  return (
    <>
    <div className={clsx('isolate flex items-center justify-center sm:justify-start pl-10', className)}>
      {children.map((avatar, index) => (
        <div
          key={index}
          style={{zIndex: 5 - index}}
          className={clsx(
            'relative -ml-10 flex-shrink-0 overflow-hidden rounded-full border-2 border-bg-alt bg-alt',
          )}
        >
          {avatar}
        </div>
      ))}
      {!isMobile() && (
      <div className={clsx('isolate flex items-center justify-center sm:justify-start pl-10', className)}>
        <div className="whitespace-nowrap text-sm">
          {!isMobile() ? (
            <>
              {firstLink && label ? (
                <Link to={firstLink} className="hover:underline">
                  {label}
                </Link>
              ) : label ? (
                <span>
                  {label}
                </span>
              ) : null}
            </>
          ) : (
            <StackTrigger moveFocusToDialog={false} title={firstArtist?.name}>
              <span>
                {label}
              </span>
              <ArtistPage artist={firstArtist} />
            </StackTrigger>
          )}
          
        </div>
        {showMore && children.length > 1 && (
            <div>
              {' '}
              <Trans
                message="+ :count more"
                values={{count: children.length - 1}}
              />
            </div>
          )}
      </div>
    )}
    </div>
    {isMobile() && (
      <div className={clsx('isolate flex items-center justify-center sm:justify-start', className)}>
        <div className="whitespace-nowrap text-sm">
          {!isMobile() ? (
            <>
              {firstLink && label ? (
                <Link to={firstLink} className="hover:underline">
                  {label}
                </Link>
              ) : label ? (
                <span>
                  {label}
                </span>
              ) : null}
            </>
          ) : (
            <StackTrigger moveFocusToDialog={false} title={firstArtist?.name}>
              <span>
                {label}
              </span>
              <ArtistPage artist={firstArtist} />
            </StackTrigger>
          )}
          
        </div>
        {showMore && children.length > 1 && (
            <div>
              {' '}
              <Trans
                message="+ :count more"
                values={{count: children.length - 1}}
              />
            </div>
          )}
      </div>
    )}
    </>
  );
}
